export const FontSizeList = [
  { size: '40', content: '40' },
  { size: '32', content: '32' },
  { size: '24', content: '24' },
  { size: '20', content: '20' },
  { size: '16', content: '16' },
  { size: '14', content: '14' },
  { size: '12', content: '12' },
  { size: '10', content: '10' },
];

export const FontList = [
  { font: '프리텐다드', content: '프리텐다드' },
  { font: '나눔고딕', content: '나눔고딕' },
  { font: '본명조', content: '본명조' },
  { font: 'D2코딩체', content: 'D2코딩체' },
  { font: '교보손글씨체', content: '교보손글씨체' },
  { font: '어비지슉체', content: '어비지슉체' },
  { font: '치킨체', content: '치킨체' },
  { font: '메이플스토리', content: '메이플스토리' },
  { font: '조선궁서체', content: '조선궁서체' },
];
